"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPicker = void 0;
const react_1 = __importStar(require("react"));
const react_virtuoso_1 = require("react-virtuoso");
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
// metadata from https://fonts.google.com/metadata/icons
// TODO: consider proxying the data from server side
const icon_metadata_json_1 = __importDefault(require("./icon-metadata.json"));
const StyledButton = (0, styled_components_1.default)(core_1.IconButton) `
  .add-icon {
    color: #ccc;
  }
`;
const StyledPopover = (0, styled_components_1.default)(core_1.Popover) `
  .popover-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .search-field {
    padding: 12px;
  }
  .virtual-list {
    flex: 1;
  }
  .icon {
    font-size: 24px;
  }
`;
const StyledList = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  padding: 12px;
`;
const StyledItem = styled_components_1.default.div `
  padding: 3px;
`;
const IconPicker = (_a) => {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    const [search, setSearch] = (0, react_1.useState)('');
    const [value, setValue] = (0, react_1.useState)(props.value);
    const [icons, setIcons] = (0, react_1.useState)(icon_metadata_json_1.default.icons);
    const timerRef = (0, react_1.useRef)();
    const [anchorElement, setAnchorElement] = (0, react_1.useState)();
    // handle value reset from parent
    (0, react_1.useEffect)(() => setValue(value), [value]);
    // debounce search
    (0, react_1.useEffect)(() => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setIcons(() => search
                ? icon_metadata_json_1.default.icons.filter(icon => icon.name.includes(search) ||
                    icon.categories.includes(search) ||
                    icon.tags.some(t => t.includes(search)))
                : icon_metadata_json_1.default.icons);
        }, 500);
    }, [search]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledButton, { className: 'icon-picker', size: 'small', onClick: event => setAnchorElement(event.currentTarget) }, value ? react_1.default.createElement(core_1.Icon, null, value) : react_1.default.createElement(core_1.Icon, { className: 'add-icon' }, "add")),
        anchorElement && (react_1.default.createElement(StyledPopover, { anchorEl: anchorElement, keepMounted: true, open: Boolean(anchorElement), onClose: e => setAnchorElement(undefined), PaperProps: {
                style: {
                    width: 240,
                    height: '100%',
                    maxHeight: 480,
                    overflow: 'hidden'
                }
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            } },
            react_1.default.createElement("div", { className: 'popover-content' },
                react_1.default.createElement("div", { className: 'search-field' },
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', placeholder: 'Search Icons', value: search, onChange: event => {
                            const value = event.target.value;
                            setSearch(value);
                        } })),
                react_1.default.createElement("div", { className: 'virtual-list' },
                    react_1.default.createElement(react_virtuoso_1.VirtuosoGrid, { totalCount: icons.length, 
                        // overscan={100}
                        components: {
                            List: StyledList,
                            Item: StyledItem
                        }, itemContent: index => (react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => {
                                setValue(icons[index].name);
                                onChange === null || onChange === void 0 ? void 0 : onChange(icons[index].name);
                            } },
                            react_1.default.createElement(core_1.Icon, { className: 'icon' }, icons[index].name))) })))))));
};
exports.IconPicker = IconPicker;
exports.default = exports.IconPicker;
//# sourceMappingURL=IconPicker.js.map